import React from 'react';
import { Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import Button from '../button/Button';
import colors from '../../styles/colors';
import { isMobile } from 'react-device-detect';

interface InfoBannerProps {
  title: string;
  text: string;
  buttonText?: string;
  buttonAction?: any;
  img?: any;
  imgStyle?: any;
}
const InfoBanner: React.FC<InfoBannerProps> = (props: any) => {
  const useStyles = makeStyles({
    paper: {
      padding: '30px'
    },
    header: {
      marginBottom: '10px',
      fontWeight: 500
    },
    secondaryText: {
      color: colors.secondaryText
    },
    icon: {
      width: '100%'
    }
  });

  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <Grid container justify="center" spacing={4} alignItems="center">
        <Grid item xs={12}>
          <Typography className={classes.header} component="p">
            {props.title}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={3}
          lg={3}
          style={{ textAlign: 'center' }}
        >
          <img
            src={props.img}
            className={classes.icon}
            style={props.imgStyle}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={9} lg={9}>
          <p className={classes.secondaryText}>{props.text}</p>
        </Grid>
        <Grid
          item
          xs={12}
          style={{ textAlign: isMobile ? 'center' : 'right', paddingTop: 0 }}
        >
          <Button primary onClick={props.buttonAction}>
            {props.buttonText || 'Learn more'}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default InfoBanner;
